import React, { Component } from 'react';
import PropTypes from 'prop-types';
// Redux
import { connect } from 'react-redux';

// Google Places Suggest Component
import Geosuggest from '@ubilabs/react-geosuggest';

import withStyles from 'isomorphic-style-loader/lib/withStyles';

// Redux Action
import { setPersonalizedValues } from '../../actions/personalized';

// Redux actions
import { getLocationData } from '../../actions/getLocation';

// Google Maps Loader Helper
import { loadGoogleMaps, isGoogleMapsLoaded } from '../../helpers/googleMapsLoader';

import s from '!isomorphic-style-loader/!css-loader!@ubilabs/react-geosuggest/module/geosuggest.css';

class PlaceSuggest extends Component {

  static propTypes = {
    label: PropTypes.string,
    className: PropTypes.string,
    containerClassName: PropTypes.string,
    setPersonalizedValues: PropTypes.any,
    googleMaps: PropTypes.object,
    personalized: PropTypes.shape({
      location: PropTypes.string,
      lat: PropTypes.number,
      lng: PropTypes.number,
      geography: PropTypes.string
    })
  };

  static defaultProps = {
    personalized: {
      location: null
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      googleMapsLoaded: false
    };
    this.onSuggestSelect = this.onSuggestSelect.bind(this);
  }

  async componentDidMount() {
    // Load Google Maps using official loader
    if (!isGoogleMapsLoaded()) {
      await loadGoogleMaps();
    }
    this.setState({ googleMapsLoaded: true });
  }

  onSuggestSelect(data) {
    return data ? this.props.getLocationData(data.description) : '';
  }

  render() {
    const { label, className, containerClassName, personalized } = this.props;
    const { googleMapsLoaded } = this.state;

    return (
      <div>
        {googleMapsLoaded && (
          <Geosuggest
            ref={el => this._geoSuggest = el}
            placeholder={label}
            inputClassName={className}
            className={containerClassName}
            initialValue={personalized.location}
            onSuggestSelect={this.onSuggestSelect}
            onKeyPress={e => { if (e.key === 'Enter') e.preventDefault(); }}
            autoComplete='off'
          />
        )}
      </div>
    )
  }
}

const mapState = (state) => ({});

const mapDispatch = {
  setPersonalizedValues,
  getLocationData
};

export default withStyles(s)(connect(mapState, mapDispatch)(PlaceSuggest));